import React, { useContext } from 'react';

import { UploadedFile } from '../../../../api-client';
import IdentificationContext from '../../../context/IdentificationContext';
import IdentificationFileUpload from '../IdentificationFileUpload';

const ThirdScanUpload = () => {
  const context: any = useContext(IdentificationContext);

  const loadFiles = (files: Array<UploadedFile>) => {
    context.setThirdPassportScans(files);
  };

  return (
    <IdentificationFileUpload
      prefix="third"
      text="Разворот с информацией о ранее выданных паспортах"
      files={context.thirdPassportScans}
      onUploaded={loadFiles}
    />
  );
};

export default ThirdScanUpload;
